import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { Button } from '../../../styles/GlobalComponents';

import { CaptionText, P2, P3 } from '../../../styles/FontStyles';
import { VirtualOfficePlan } from './VirtualOfficePlan';
import { buyVirtualOffice } from '../../../views/Settings/Settings.actions';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { InputBackOffice } from '../InputBackoffice';

import { lightTheme } from '../../../styles/GlobalStyles';

import { UserAddress } from '../../../views/Marketplace/Maeketplace.types';
import axios from 'axios';
import { ErrorToast } from '../Toasts/Toasts';

interface VirtualOfficeSelectedPlanProps {
  selected: any;
}

export const VirtualOfficeSubscription = ({
  selected
}: VirtualOfficeSelectedPlanProps) => {
  const [userAddress, setUserAddress] = useState<UserAddress>({
    address: '',
    city: '',
    country: '',
    countryCode: '',
    zipCode: ''
  });

  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const [email, setEmail] = useState(userInfo?.user?.email);

  const getUserPermanentAddress = async () => {
    const apiURL = process.env.REACT_APP_API_URL;
    const { data } = await axios.get(`${apiURL}/user/permanent-address`);

    setUserAddress(data?.data?.userAddress);
  };

  useEffect(() => {
    getUserPermanentAddress();
  }, []);

  return (
    <div>
      <P3 bold mb='8'>
        Payment Method
      </P3>
      <InputBackOffice disabled value={'Credit Card'} />
      <P3 bold mb='8'>
        Invoice to
      </P3>
      <InputBackOffice
        disabled
        value={`${userInfo?.user?.name} ${userInfo?.user?.surname}`}
      />
      <InputBackOffice
        disabled
        value={`${userAddress?.address}, ${userAddress?.city}, ${userAddress?.country}`}
      />
      <P3 bold mb='8'>
        Email
      </P3>
      <InputBackOffice
        placeholder='Enter your email address'
        value={email}
        onChange={setEmail}
      />
      {email?.length > 30 && (
        <CaptionText mb='20' color={lightTheme.colors.error500}>
          The payment provider requires an email address shorter than 30
          characters.
        </CaptionText>
      )}

      <Button
        mb={40}
        onClick={() => {
          if (email.length > 30) {
            ErrorToast(
              'Payment provider requires email less than 30 characters'
            );
          } else {
            dispatch(buyVirtualOffice({ productId: selected.id, email }));
          }
        }}>
        Create Order
      </Button>
    </div>
  );
};
